import React from 'react';

const Checkbox = ({className, fill, stroke, style, strokeWidth, height, width}) => (
  <span className={className} style={{width, height, ...style}}>
    <svg id='Layer_1_2_' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'>
      <path fill={fill} stroke={stroke} strokeWidth={strokeWidth} d='M37.11,5H12.89C8.36,5,5,8.53,5,13.29v23.42C5,41.47,8.36,45,12.89,45h24.23c4.53,0,7.89-3.53,7.89-8.29 V13.29C45,8.53,41.64,5,37.11,5z'
        id='Rounded_Rectangle_Auto_Shape' />
    </svg>
  </span>
);

Checkbox.defaultProps = {
  className: "checkbox",
  fill:"none",
  stroke:"#666",
  strokeWidth: "3",
  width:"27px",
  height:"27px",
  style: {
    margin: "-1px 10px 0 0",
    verticalAlign: "middle",
    display:"inline-block",
  },
}

export default Checkbox;